export const SITE_URL = "https://sempresera.com";

// PLACEHOLDER — swap for the real ticketing portal URL (ConnectWise / Autotask / HaloPSA) before launch.
export const CLIENT_PORTAL_URL = "https://portal.sempresera.com";
